import api from "./api.service";

/**
 * Auth Service
 * Reusable authentication methods.
 */
export const authService = {
  login: async (user_name, password) => {
    const response = await api.post("/login", { user_name, password });
    const {
      data: {
        sessiontoken,
        user: { rol, empresa, empresaId },
      },
    } = response;

    // Persist session
    sessionStorage.setItem("satiRol", rol);
    sessionStorage.setItem("satiAuth", sessiontoken);
    sessionStorage.setItem("empresaId", String(empresaId));
    sessionStorage.setItem("healthWeekStatus", empresa.healthWeekStatus);
    sessionStorage.setItem("healthWeekStartDate", empresa.healthWeekStartDate);

    return response;
  },

  logout: () => {
    sessionStorage.removeItem("satiRol");
    sessionStorage.removeItem("satiAuth");
    sessionStorage.removeItem("empresaId");
    sessionStorage.removeItem("healthWeekStatus");
    sessionStorage.removeItem("healthWeekStartDate");
    return Promise.resolve({});
  },
};

export default authService;
